import React, { useState } from "react";
import {
    Box,
    CircularProgress,
    Link,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@mui/material";

import CampoEdicaoInline from "./CampoEdicaoInline";
import { AZUL, BORDA_SUAVE_CLARA, NAVY, formatarMoeda } from "./utils";

const SelectTipoServico = ({ servico, tiposServico, disabled, onSalvar }) => {
    const [salvando, setSalvando] = useState(false);
    const [erro, setErro] = useState("");

    async function handleChange(event) {
        setSalvando(true);
        setErro("");
        try {
            await onSalvar(Number(event.target.value));
        } catch (e) {
            setErro(e?.response?.data?.mensagem || "Erro ao salvar. Tente novamente.");
        } finally {
            setSalvando(false);
        }
    }

    return (
        <>
            <TextField
                select
                size="small"
                value={servico.tipoServicoId ?? ""}
                onChange={handleChange}
                disabled={disabled || salvando}
                sx={{ minWidth: "10rem", backgroundColor: "white" }}
                inputProps={{ "aria-label": `Tipo de serviço de ${servico.tipoServicoNome || "sem tipo"}` }}
                InputProps={salvando ? { endAdornment: <CircularProgress size={14} /> } : undefined}
            >
                {servico.tipoServicoId == null && <MenuItem value="">Selecione...</MenuItem>}
                {tiposServico.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>{tipo.tituloTipo}</MenuItem>
                ))}
            </TextField>
            {erro && (
                <Typography variant="caption" color="error" display="block">
                    {erro}
                </Typography>
            )}
        </>
    );
};

const SubgradeServicosRevenda = ({
    item,
    tiposServico = [],
    bloqueado = false,
    onSalvarCodigoServico,
    onSalvarObservacaoNotaFiscal,
    onSalvarTipoServico,
    onVerClientes
}) => {
    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{ border: `1px solid ${BORDA_SUAVE_CLARA}`, borderRadius: "12px" }}
        >
            <Table
                size="small"
                sx={{
                    "& .MuiTableCell-head": { fontWeight: 700, backgroundColor: "white", color: NAVY, borderBottom: `1px solid ${BORDA_SUAVE_CLARA}` },
                    "& .MuiTableCell-root": { borderBottom: `1px solid ${BORDA_SUAVE_CLARA}` }
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell>Tipo de Serviço</TableCell>
                        <TableCell>Cód. Serviço SISDM</TableCell>
                        <TableCell align="right">Valor Total</TableCell>
                        <TableCell>Produto</TableCell>
                        <TableCell>Vertical</TableCell>
                        <TableCell>Detalhes</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {item.servicos?.map((servico) => (
                        <React.Fragment key={`${item.id}-${servico.tipoServicoId ?? "sem-tipo"}`}>
                            <TableRow hover sx={{ "& > td": { borderBottom: "none" } }}>
                                <TableCell>
                                    <SelectTipoServico
                                        servico={servico}
                                        tiposServico={tiposServico}
                                        disabled={bloqueado || !servico.faturamentoIds?.length}
                                        onSalvar={(tipoServicoId) => onSalvarTipoServico(servico, tipoServicoId)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <CampoEdicaoInline
                                        valor={servico.codigoServicoSisdm}
                                        disabled={bloqueado || !servico.faturamentoIds?.length}
                                        ariaLabel={`Código de serviço SISDM de ${servico.tipoServicoNome || "sem tipo"}`}
                                        onSalvar={(valor) => onSalvarCodigoServico(servico, valor)}
                                    />
                                </TableCell>
                                <TableCell align="right">{formatarMoeda(servico.totalValor)}</TableCell>
                                <TableCell>{servico.produto || "—"}</TableCell>
                                <TableCell>{servico.vertical || "—"}</TableCell>
                                <TableCell>
                                    <Link
                                        component="button"
                                        type="button"
                                        underline="hover"
                                        disabled={!servico.faturamentoIds?.length}
                                        onClick={() => onVerClientes(item, servico)}
                                        sx={{ color: AZUL, fontWeight: 600, fontSize: "0.875rem" }}
                                    >
                                        Ver clientes →
                                    </Link>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={6} sx={{ pt: 0 }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                                        <Typography variant="caption" color="text.secondary">
                                            Observação de NF:
                                        </Typography>
                                        <CampoEdicaoInline
                                            valor={servico.observacaoNotaFiscal}
                                            tipo="texto"
                                            permitirVazio
                                            disabled={bloqueado || !servico.faturamentoIds?.length}
                                            ariaLabel={`Observação de NF de ${servico.tipoServicoNome || "sem tipo"}`}
                                            onSalvar={(valor) => onSalvarObservacaoNotaFiscal(servico, valor)}
                                        />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default React.memo(SubgradeServicosRevenda);
